export const videoConsultationParams = {
  disableAudio: { param: 'audio', title: 'disableAudio', enable: 'off', disable: 'on' },
  disableVideo: { param: 'video', title: 'disableVideo', enable: 'off', disable: 'on' },
  chat: { param: 'chat', title: 'enableChat', enable: 'on', disable: 'off' },
  disablePeopleList: { param: 'people', title: 'disablePeopleList', enable: 'off', disable: 'on' },
  disableLeaveButton: { param: 'leaveButton', title: 'disableLeaveButton', enable: 'off', disable: 'on' },
  recording: { param: 'recording', title: 'enableRecording', enable: 'on', disable: 'off' },
  screenshare: { param: 'screenshare', title: 'enableScreenshare', enable: 'on', disable: 'off' },
};
